const BlogSkeleton = () => {
  return (
    <section className="py-16 bg-white dark:bg-nexus-dark">
      <div className="container space-y-8">
        {/* Category Skeleton */}
        <div className="flex flex-wrap gap-2 justify-center">
          {Array.from({ length: 4 }).map((_, idx) => (
            <div
              key={idx}
              className="h-8 w-24 rounded-full bg-gray-200 dark:bg-gray-700 animate-pulse"
            />
          ))}
        </div>

        {/* Blog cards skeleton */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.from({ length: 6 }).map((_, idx) => (
            <div
              key={idx}
              className="rounded-lg border border-gray-200 dark:border-gray-700 p-4 animate-pulse"
            >
              <div className="h-40 w-full rounded bg-gray-200 dark:bg-gray-700 mb-4" />
              <div className="h-4 w-3/4 bg-gray-200 dark:bg-gray-700 mb-2 rounded" />
              <div className="h-4 w-1/2 bg-gray-200 dark:bg-gray-700 mb-2 rounded" />
              <div className="h-3 w-1/4 bg-gray-200 dark:bg-gray-700 rounded" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogSkeleton;
